/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, Input, TemplateRef } from "@angular/core";
import { ɵNzTabBodyComponent } from "ng-zorro-antd/tabs";

@Component({
  selector: "[ui-tab-body]",
  exportAs: "uiTabBody",
  templateUrl: "./tab-body.component.html",
})
export class UiTabBodyComponent extends ɵNzTabBodyComponent {
  @Input() public content: TemplateRef<void> | null = null;
  @Input() public active = false;
  @Input() public tabPaneAnimated = true;
  @Input() public forceRender = false;
}
